<template>
  <div>
    <div v-if="state === 'select_time' && $vuetify.breakpoint.mdAndDown">
      <div class="mobileHeaderArea">
        <div class="mobileHeader  mb-1 d-flex flex-column justify-center">
          <div class="d-flex" @click="returnBack">
            <div class=" d-flex flex-column justify-center">
              <img src="../../assets/image/user-journey/arrow-narrow-right-black.svg" alt="">
            </div>
            <div class=" d-flex flex-column justify-center">
              بررسی و رزرو نوبت
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class=" mobileArea" v-else>
      <div class="headerArea">
        <v-row class="text-center">
          <v-col cols="4" lg="4"></v-col>
          <v-col cols="4" lg="4" class="d-flex flex-column justify-center  align-center text-center">
            <img src="../../assets/image/user-journey/Logo.7d6477941.svg" width="75" alt="">
          </v-col>
          <v-col cols="4" lg="4" class="d-flex flex-column justify-center text-left">
            <div class="returnBtn d-flex justify-end"
                 @click="returnBack"
                 v-if="!includesList.includes(state)">
              <div class="d-flex flex-column justify-center"
                   v-if="$vuetify.breakpoint.mdAndUp">
              </div>
              <div class="d-flex flex-column justify-center">
                <img src="../../assets/image/user-journey/chevron-left.svg" width="24px" height="24px" alt="">
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: String
  },
  data() {
    return {
      includesList: [
        'auth', 'suggest_doctors','matchMaking'
      ]
    }
  },
  methods: {

    returnBack() {
      this.$emit('goBack')
    }
  },
  mounted() {
    // Add/remove 'matchMaking' to header hide list via event bus
    this.$onEvent('addMatchMakingToHeaderIncludes', () => {
      if (!this.includesList.includes('matchMaking')) {
        this.includesList.push('matchMaking')
      }
    })
    this.$onEvent('removeMatchMakingFromHeaderIncludes', () => {
      const i = this.includesList.indexOf('matchMaking')
      if (i !== -1) {
        this.includesList.splice(i, 1)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .headerArea {
    padding: 0px 20px !important;
    height: 80px !important;
    z-index: 10;
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
  .mobileArea {
    margin-bottom: 80px;
  }
  .mobileHeader {
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 10 !important;
  }
  .mobileHeaderArea {
    height: 50px;
  }
}

.mobileHeader {
  height: 52px;
  padding: 0px 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  font-size: 18px;
  font-weight: 700;
  z-index: 9999;
  background: white;
}

.mobileHeaderArea {
  background: #F6F9FC;
}

.headerArea {
  background: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  height: 88px;
  display: flex;
  flex-direction: column;
  padding: 0px 85px;
  justify-content: center;
}

.returnBtn {
  color: #212121;
  /* Body/Medium/Medium16 */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
}
</style>